import React, {Component} from 'react';
import PropTypes from 'prop-types';
import MaskedInput from "../../../controls/MaskedInput";
import './CodeForm.css'
import ActionLink from "../../../controls/ActionLink";
import BackEnd from "../../../backend/BackEnd";

class CodeForm extends Component {
    static propTypes = {
        phoneNumber: PropTypes.string,
        onSubmit: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        code: '',
        timerValue: 60,
        canResendCode: false
    };
    sendSecurityCode = new BackEnd.Authentication.SendSecurityCode();

    componentDidMount() {
        this.resetTimer();
    }

    componentWillUnmount() {
        if (this.interval)
            clearInterval(this.interval);
    }

    render() {
        const {phoneNumber} = this.props;
        return (
            <div>
                <h2 className="m-t-0 m-b-4 text-xs-center font-weight-semibold font-size-20">Подтверждение номера</h2>
                <form className="panel p-a-4"
                      onSubmit={event => {
                          this.checkCode();
                          event.preventDefault();
                      }}>
                    <fieldset className="form-group form-group-lg">
                        <label className="text-center m-b-2" htmlFor="code">
                            Мы отправили код безопасности на номер +{phoneNumber}
                        </label>
                        <MaskedInput type="text" className="form-control text-center" id="code"
                                     mask="9 9 9 9"
                                     value={this.state.code}
                                     onChange={event => this.setState({code: event.target.value})}/>
                    </fieldset>
                    <div className="text-center">
                        {
                            !this.state.canResendCode &&
                            <span className="font-size-12">
                                Повторная отправка возможна через {this.state.timerValue} сек.
                            </span>
                        }
                        {
                            this.state.canResendCode &&
                            <ActionLink className="font-size-12"
                                        onClick={() => this.resendCode()}>
                                Запросить код повторно
                            </ActionLink>
                        }
                    </div>
                    <button type="button" className="btn btn-block btn-lg btn-primary m-t-3"
                            disabled={!this.isFormValid()}
                            onClick={() => this.checkCode()}>
                        Проверить
                    </button>
                </form>
            </div>
        );
    }

    isFormValid() {
        return this.state.code.replace(/[^\d]/g, '').length === 4;
    }

    intervalTick() {
        if (this.state.timerValue === 0)
            return;

        this.setState({
            timerValue: this.state.timerValue - 1,
            canResendCode: this.state.timerValue === 1
        });
    }

    resetTimer() {
        if (this.interval) clearInterval(this.interval);

        this.setState({
            timerValue: 60,
            canResendCode: false
        });

        this.interval = setInterval(() => this.intervalTick(), 1000);
    }

    async resendCode() {
        let result = await this.sendSecurityCode.call({
            dto: {
                phoneNumber: this.props.phoneNumber
            }
        });

        this.resetTimer();
    }

    checkCode() {
        const {onSubmit} = this.props;

        if (this.isFormValid()) {
            onSubmit(this.state.code)
        }
    }
}

export default CodeForm;


// WEBPACK FOOTER //
// ./src/pages/Login/components/CodeForm.js